import React from 'react'
import BookRideSection from '../components/sections/BookRideSection'
import ContactForm from './form/ContactForm'
import useMeta from '../hooks/useMeta';
import Meta from '../components/common/Meta';

const ContactUs = () => {
    const meta = useMeta("contact-us");
    // console.log("contact-us Page Meta:", meta);
    return (
        <>
            {/* Meta tags for SEO */}
            {meta && (
                <Meta
                    title={meta.meta_title}
                    description={meta.meta_description}
                    keywords={meta.meta_keywords}
                />
            )}
            <section className="coverage_wrap contactCoverage_wrap">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-7 col-md-6 col-12 d-md-block d-none">
                            <div className="triCity_roadMAp wow fadeInLeft"
                                style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                                <img src="assets/img/all-images/roadMap-main.png" alt="Tricity coverage map showing Chandigarh, Mohali & Panchkula" />
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6 col-12">
                            <div className="text_roadMAp wow fadeInRight" style={{ visibility: 'visible', animationName: 'fadeInRight' }}>
                                <h3><b>Delhi and Tricity Coverage</b></h3>
                                <h4>Seamless Travel From <br /> <b>Delhi, Chandigarh, Mohali & Panchkula</b></h4>
                                <p><i>Expanding to other cities soon...</i></p>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-6 col-12 d-md-none d-block">
                            <div className="triCity_roadMAp wow fadeInLeft animated"
                                style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                                <img src="assets/img/all-images/roadmap-mob.png" alt="Tricity coverage map (mobile)" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="workWith_wrap help_wrap section_pb section_pt">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="work_left help_left">
                                <h2 className="wow fadeInLeft" data-wow-duration="1s">How Can We Help <br /> You Today?
                                </h2>
                                <p className="wow fadeInLeft" data-wow-duration="2s">Our team is just a message away! Whether it’s
                                    about your ride, becoming a partner, or general queries.</p>

                                <div className="contact_address">
                                    <h3><i className="fas fa-map-marker-alt"></i> Address</h3>
                                    <p>Inclusion Software Solutions
                                        <br />
                                        D-234 C&P, Industrial Area, Phase 8B,
                                        <br />
                                        Sector 74, SAS Nagar, Punjab 160055
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="business_right wow fadeInRight">
                                <h2>Have Questions? Write To Us Below</h2>
                                <ContactForm />
                            </div>
                        </div>


                        {/* <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="business_right wow fadeInRight">
                                <h2>Have Questions? Write To Us Below</h2>
                                <form id="contactForm">
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <div className="mb-2">
                                                <label for="" className="form-label">Full Name*</label>
                                                <input type="text" className="form-control" id="name" name="name"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <div className="mb-2">
                                                <label for="" className="form-label">Email Address*</label>
                                                <input type="text" className="form-control" id="email" name="email"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div className="mb-2">
                                                <label for="" className="form-label">Phone*</label>
                                                <input type="number" className="form-control" id="phone" name="phone"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <div className="mb-2">
                                                <label for="" className="form-label">Select Subject*</label>
                                                <select className="form-control" id="subject" name="subject">
                                                    <option value="">Select</option>
                                                    <option value="General">General</option>
                                                    <option value="Ride">Ride</option>
                                                    <option value="Partner">Partner</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div className="mb-2">
                                                <label for="" className="form-label">Message*</label>
                                                <textarea id="message" name="message" rows="5" className="form-control"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <button type="submit" id="submitBtn" className="btn">Submit</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>


            {/* Book a Ride Section */}
            <BookRideSection />
        </>
    )
}

export default ContactUs